(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["featured-products"] && !window.DesignMode) return;
  try {
    
$('.best-sellers-carousel').slick({
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: '<i class="fa fa-angle-left" title="previous"></i>',
  nextArrow: '<i class="fa fa-angle-right" title="Next"></i>',
  adaptiveHeight: true,
  dots:true,
  responsive: [
    {
      breakpoint: 1170,
      settings: {
        slidesToShow: 1
      }
    }
  ]  
}); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-best-sellers"]) return;
  try {
    
$('.best-sellers-carousel').slick({
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<i class="fa fa-angle-left" title="previous"></i>',
  nextArrow: '<i class="fa fa-angle-right" title="Next"></i>',
  adaptiveHeight: true,
  dots:true,
  responsive: [
    {
      breakpoint: 1170,
      settings: {
        slidesToShow: 1

      }
    }
  ]  
}); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
$( document ).ajaxComplete(function() {
  $('.product-recommendations-carousel').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<i class="fa fa-angle-left" title="previous"></i>',
    nextArrow: '<i class="fa fa-angle-right" title="Next"></i>',
    adaptiveHeight: true,
    dots: true,
    responsive: [
      {
        breakpoint: 1170,
        settings: {
          slidesToShow: 1
        }
      }
    ]  
  }); 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-reviews"] && !window.DesignMode) return;
  try {
    
    $(document).ready(function(){
      $(".reviews").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<i class="fa fa-angle-left" title="previous"></i>',
        nextArrow: '<i class="fa fa-angle-right" title="Next"></i>'
      });
    });
    
  } catch(e) { console.error(e); }
})();

})();
